import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { AccountLookupService } from "./AccountLookupService";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { ITraderGroupPromiseLookupService } from "../ITraderGroupPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { TraderGroupLookupService } from "./TraderGroupLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class TraderGroupReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.TradingGroupImpl>
  implements ITraderGroupPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      CubiqTS.TradingGroupImpl,
      "TradingGroupImpl",
      CubiqTS.ModelUpdateImpl,
      true,
      new TraderGroupLookupService(),
    );
  }

  getTraderGroup(id: CubiqTS.Long): Promise<CubiqTS.TradingGroupImpl> {
    let request = new UiArguments("getTraderGroup");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }
  getTraderGroupForSid(sid: string): Promise<CubiqTS.TradingGroupImpl> {
    let request = new UiArguments("getTraderGroupForSid");
    let arg1 = new FnArg(sid, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }
}
